import angular from 'angular';

angular.module('neurotecAbisWebClientApp')
	.directive('stickyHeader', () => ({
		template: require('../../views/directives/sticky-header.html'),
		restrict: 'E',
		replace: true
	}));
